import { apiGetProducts } from "@lib/api/product";
import { createYupSync } from "@lib/helpers/TableHelper";
import { noteSchema as yupSchema } from "@lib/schemas/note";
import { Product } from "@lib/types/Billing";
import { Note } from "@lib/types/Note";
import { useQuery } from "@tanstack/react-query";
import { Form, FormInstance, Input, Select, Typography } from "antd";
import { useEffect } from "react";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props<T> = {
  form: FormInstance<T>;
  loading: boolean;
  note?: T;
  product?: Product;
};

export default function NoteProductInput<T extends Note>(props: Props<T>) {
  const { loading, note, product, form } = props;
  const { messages } = useIntl();

  const isNotEditable = note || product;

  const { data, isLoading } = useQuery({
    queryFn: () =>
      apiGetProducts({
        page: 1,
        limit: 100,
        sort: "createdAt,DESC",
      }),
    queryKey: ["products-dropdown"],
    enabled: !isNotEditable && !loading,
  });

  useEffect(() => {
    if (!form) return;
    if (isNotEditable) {
      form?.setFieldsValue({
        productId: (note?.product?.id || product?.id) as any,
      });
    }
  }, [isNotEditable]);

  if (note && !note?.product) return null;

  return (
    <Form.Item
      name="productId"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.product"] as string}
    >
      {isNotEditable && (
        <>
          <Typography>{note?.product?.name || product?.name || ""}</Typography>
          <Input
            type="text"
            value={note?.product?.name || product?.name || ""}
            style={{ display: "none" }}
          />
        </>
      )}

      {!isNotEditable && (
        <Select
          placeholder={messages["common.makeYourChoice"] as string}
          disabled={loading || isLoading}
          showSearch
          optionFilterProp="text"
          options={data?.data?.data?.map((item) => ({
            label: item.name,
            text: item.name,
            value: item.id,
          }))}
        />
      )}
    </Form.Item>
  );
}
